// extracted by mini-css-extract-plugin
export var accountButton = "g6YkzzJxac9d_toC2cl8";
export var accountButtonAvatar = "xmTwV8lanmZ2DJmDwDAF";
export var accountButtonLabel = "U9Ydy9q3GZ15QK9BM1qj";